import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-import-qr-negoce',
  templateUrl: './import-qr-negoce.component.html',
  styleUrls: ['./import-qr-negoce.component.scss']
})
export class ImportQRNegoceComponent implements OnInit {
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;

  private modalRef!: NgbModalRef;

  constructor(private toastr: ToastrService, private modalService: NgbModal) {}

  ngOnInit(): void {
  }

    
  openModal(): void {
      const options: NgbModalOptions = {
        centered: true,
        backdrop: 'static',
        keyboard: true,
        size: 'lg',
        ariaLabelledBy: 'fileUploadModalLabel',
      };
      this.modalRef = this.modalService.open(this.modalTemplate, options);
  }
  
}
